
import Text from "../../assets/icon/NewsIcons/MainAdmin/NewsText";
import "./CkEditorStyle/ccc.css";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import "./CkEditorStyle/ccc.css";
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Quill from 'quill';
import React, { useState, useEffect } from "react";
import Cookies from 'universal-cookie';
import { axiosReq } from "../../commons/axiosReq";
import { useNavigate } from "react-router-dom";

const MainAdminAboutUs = () => {

    const [ck, setCk] = useState(false);



    const [editorContent, setEditorContent] = useState('');

    const handleEditorChange = (content) => {
        setEditorContent(content);
    };
    const [showDeleteModal, setShowDeleteModal] = React.useState(false);
    const [reCheck, setRecheck] = useState(false);
    const [data, setData] = useState();

    const [count, setCount] = useState();

    let navigate = useNavigate();


    const GetData = async () => {
        const writersData = await axiosReq("Admins/GetContext", "get");
        console.log("slm")
        console.log(writersData)
        setEditorContent(writersData[0]?.aboutUs)
    }
    const auth = async () => {
        const cookies = new Cookies();
        var token = cookies.get('token');
        console.log(token)
        console.log(cookies.get('role'))
        if (!token) {
            navigate("/admin");
        } else {
            if (cookies.get('role') == "Admin") {

                GetData()
            }


            else {
                navigate("/admin");

            }
        }
    }
    useEffect(() => {

        auth();
    }, [reCheck]);
    const CreateAboutUs = async () => {
        const dataUser = await axiosReq("Admins/UpdateContext", "put", {
            contextId:1,
            aboutUs: editorContent
        });
        console.log(dataUser)
        if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
            //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
            alert("موفقیت آمیز");
            //navigate("/mainAdmin/newsPendingConfirmation")

        }
        else {

        }
    }
    const Font = ReactQuill.Quill.import('formats/font'); // <<<< ReactQuill exports it
    Font.whitelist = ['IRANYekanNormal']; // allow ONLY these fonts and the default
    ReactQuill.Quill.register(Font, true);

    const toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],
        ['link', 'image', 'video', 'formula'],

        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }, { 'align': [] }],
        ['clean'],                         // text direction

        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        [{ 'font': Font.whitelist }],


        // remove formatting button
    ];



    return (
        <div className='pb-[10px]'>
            <div className="flex items-center justify-between border-b-2 border-borderGray p-[20px]">

                <div className="flex justify-start items-start">
                    <div><Text /></div>
                    <p className="font-IRANYekanExtra text-[15px] text-mainColor2 mr-[15px]">متن صفحه درباره ما</p>
                </div>
                <div>
                    <button onClick={()=>CreateAboutUs()} className="w-[138px] h-[39px] bg-Orange2 shadow-search-shadow rounded-[10px] flex justify-center items-center ml-6">
                        <p className="font-IRANYekanBold text-[18px] text-white">ذخیره متن</p>
                    </button>
                </div>

            </div>
            <div className="mt-[20px] mb-[80px] mx-[53px] border-[2px] rounded-[15px] border-borderGray h-[1266px] ">
                {/* <div id="editor">
                <p>متن را اینجا بنویسید</p>
                </div> */}

                <ReactQuill
                    value={editorContent}
                    onChange={handleEditorChange}
                    modules={{
                        toolbar: toolbarOptions
                    }

                    }
                    formats={[
                        'header', 'font', 'size',
                        'bold', 'italic', 'underline', 'strike', 'blockquote',
                        'list', 'bullet', 'indent',
                        'link', 'image', 'align'
                    ]}

                    placeholder="متن را اینجا بنویسید"
                    style={{ direction: 'rtl', textAlign: 'right' }}
                />
            </div>
        </div>


    )
}

export default MainAdminAboutUs;